import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {

  constructor(private http: HttpClient) { }

  updateCompanySettings(settings: any) {
    const data = this.http.post('/company', settings);
    return data;
  }

  getCompanySettings(): Observable<any[]> {
    const data =  this.http.get<any[]>('/company');
    return data;
  }

}
